// @flow
export const REDIRECT_PERFORM = 'REDIRECT/PERFORM';

type RedirectPerformActionType = 'REDIRECT/PERFORM';
export type ActionType = RedirectPerformActionType;

type RedirectPerformAction = {
    type: RedirectPerformActionType,
    payload: {
        url: string
    }
};
export type Action = RedirectPerformAction;

const ACTION_CREATORS = {
    redirect(url: string): Action {
        return {
            type: REDIRECT_PERFORM,
            payload: {url}
        };
    }
};

export default {
    ...ACTION_CREATORS
};
